/**
 * Almikia Epic PL (TASK-061): validation rules of a feedback report, shared by
 * the dialog (client-side) and the FakeRest provider (parity with the
 * `feedback_reports` CHECK constraints and rate-limit trigger from TASK-060).
 */

/** `char_length(btrim(message)) between 1 and 4000` (TASK-060). */
export const FEEDBACK_MESSAGE_MAX = 4000;

/** Reports a user may create per rolling hour (TASK-060 rate limit). */
export const FEEDBACK_RATE_LIMIT_PER_HOUR = 20;

/** Same Spanish text the SQL trigger raises, so FakeRest and Supabase agree. */
export const FEEDBACK_RATE_LIMIT_MESSAGE =
  "Enviaste demasiados comentarios en la última hora. Intenta de nuevo más tarde.";

/**
 * An error whose message is safe to show the author as is (a Spanish message
 * raised by the database or by the FakeRest guards). Any other failure shows
 * the dialog's own Spanish fallback instead of a raw technical message.
 */
export class FeedbackError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "FeedbackError";
  }
}

export type FeedbackMessageError = "empty" | "too_long";

/**
 * Validates a report message the way the database does: trimmed length must be
 * 1..4000. Returns the failure reason, or `null` when the message is valid.
 */
export const validateFeedbackMessage = (
  message: unknown,
): FeedbackMessageError | null => {
  const trimmed = typeof message === "string" ? message.trim() : "";
  if (trimmed.length === 0) return "empty";
  if (trimmed.length > FEEDBACK_MESSAGE_MAX) return "too_long";
  return null;
};
